<template>
    <span>
        <span
            :class="{
                'bg-warning': isOld(),
                'label': isOld(),
                'text-white': isOld(),
            }"
            style="padding: 3px;"
        >
            {{ relativeTime }}
        </span>
    </span>
</template>
<script>
    export default {
        props: {
            diff: {
                type: [Number, String],
                required: true,
            },
        },
        data() {
            return {
                oldnessThresholdInS: 5 * 60,
                relativeTime: String(),
                ticks: Number(this.diff),
                tickTimeout: null,
            };
        },
        destroyed() {
            clearTimeout(this.tickTimeout);
        },
        mounted() {
            this.tick();
        },
        methods: {
            isOld() {
                if (this.diff < 0) return;

                return this.ticks >= this.oldnessThresholdInS;
            },
            tick() {
                if (this.diff < 0) return;

                this.ticks++;

                var minutes = Math.floor(this.ticks / 60);

                var hours = Math.floor(minutes / 60);

                if (hours > 0) {
                    this.relativeTime = hours + ' timmar sedan';
                } else if (minutes > 0) {
                    this.relativeTime = minutes + ' minuter sedan';
                } else {
                    this.relativeTime = this.ticks + ' sekunder sedan';
                }

                this.tickTimeout = setTimeout(this.tick, 1000);
            },

        },
    };
</script>
